import React from 'react';
import {useTranslation} from "react-i18next";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import APIModel from "../../Components/APIModel";
import {DropdownItem} from "reactstrap";
import {importNewContactsToggleModal} from "../../actions/Chats";
import {useDispatch} from "react-redux";
import ImportContactsModal from "../../Components/Modals/ImportContactsModal";

const BotUsers = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const dispatch = useDispatch();

    const additionalDropdown = <DropdownItem onClick={() => dispatch(importNewContactsToggleModal(true))}>
        {t('chats.filter_dropdown.import_contacts', "Import contacts")}
    </DropdownItem>


    const BOT_USER_COLUMNS = [
        {
            name: t('audience.bot_users.columns.name', "Name"),
            selector: "name",
        },
        {
            name: t('audience.bot_users.columns.phone_number', 'Phone Number'),
            selector: "phone_number",
        },
        {
            name: t('audience.bot_users.columns.created_at', "Created at"),
            selector: "created_at",
        },
        {
            name: t('audience.bot_users.columns.tags', "Tags"),
            cell: row => <div>
                {
                    get(row, 'tags', []).map(
                        (tag, idx) => <div className='my-1' key={idx}>
                            <code className='text-secondary'>
                                {tag.name}
                            </code>
                        </div>
                    )
                }
                {
                    isEmpty(row?.tags) && '-'
                }
            </div>
        },
    ];

    return <>
        <APIModel
            heading={t('audience.bot_users.api_model.heading', 'Contacts')}
            apiPath='bot/bot_users'
            tableColumns={BOT_USER_COLUMNS}
            tableEmptyMessage={t('audience.bot_users.api_model.message_empty', "No contacts yet")}
            match={match}
            hasFilters={true}
            deletionDisabled={true}
            creationDisabled={true}
            backDisabled={false}
            apiTableAdditionalSelectOptions={additionalDropdown}
            hideFilter={["bot"]}
        />
        <ImportContactsModal/>
    </>;
};

export default BotUsers;
